import { makeTheme } from "@shared/primitive-components"
import { BODY_SIZE, SPACING, FONT_SIZE } from "../const"
import palette, { surface } from "./palette"
import borderRadius from "./borderRadius"
import media from "./media"
import shadows from "./shadows"
import grid from "./grid"
import typography, { fonts } from "./typography"

const options = {
  defaultPxSize: BODY_SIZE,
  spacing: SPACING,
  fontSize: FONT_SIZE,
}

const specfiedTheme = {
  fonts,
  palette,
  typography,
  media,
  grid,
  shadows,
  borderRadius,
  surface,
}

export const theme = makeTheme(specfiedTheme, options)
